/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

import QRAuthenticator from '@/lib/qrauthenticator';
import { mapGetters } from 'vuex';

export default {
  name: 'QRCode',
  data () {
    return {
      QRAuthenticator: null,
      QRCode: '',
      obtainingQRCode: true,
      isAuthenticating: false
    };
  },
  computed: {
    ...mapGetters('AppStore', {
      $_CONFIG: 'config'
    })
  },
  watch: {
    QRCode (newValue, oldValue) {
      this.$eventBus.$emit('sendToControls', {
        type: 'input',
        scope: 'landing',
        data: {
          field: 'QRCode',
          value: newValue
        }
      });
    },
    obtainingQRCode (newValue, oldValue) {
      this.$eventBus.$emit('sendToControls', {
        type: 'input',
        scope: 'landing',
        data: {
          field: 'obtainingQRCode',
          value: newValue
        }
      });
    },
    isAuthenticating (newValue, oldValue) {
      this.$eventBus.$emit('sendToControls', {
        type: 'input',
        scope: 'landing',
        data: {
          field: 'isAuthenticating',
          value: newValue
        }
      });
    }
  },
  created () {
    this.connectToQRAuthenticator();
  },
  mounted () {
    this.$eventBus.$emit('sendToControls', {
      type: 'input',
      scope: 'landing',
      data: {
        field: 'QRCode',
        value: this.QRCode
      }
    });
    this.$eventBus.$emit('sendToControls', {
      type: 'input',
      scope: 'landing',
      data: {
        field: 'obtainingQRCode',
        value: this.obtainingQRCode
      }
    });
    this.$eventBus.$emit('sendToControls', {
      type: 'input',
      scope: 'landing',
      data: {
        field: 'isAuthenticating',
        value: this.isAuthenticating
      }
    });
  },
  updated () {
    this.connectToQRAuthenticator();
  },
  beforeDestroy () {
    this.disconnect();
  },
  methods: {
    connectToQRAuthenticator () {
      const self = this;
      if (!self.QRAuthenticator) {
        self.obtainingQRCode = true;
        self.QRAuthenticator = new QRAuthenticator(
          self.$_CONFIG.appconfig.APP_URL,
          self.$_CONFIG.appconfig.QR_AUTHENTICATOR_PATH
        );
        self.QRAuthenticator.attachEvent('code', data => {
          self.QRCode = data;
          self.obtainingQRCode = false;
        });

        self.QRAuthenticator.attachEvent('token', data => {
          self.isAuthenticating = true;
          self.isAuthenticating = false;
          self.$emit('gotAuthToken', data);
        });

        self.QRAuthenticator.attachEvent('disconnect', () => {
          self.obtainingQRCode = true;
        });

        self.QRAuthenticator.attachEvent('error', () => {
          self.obtainingQRCode = true;
        });

        self.QRAuthenticator.connect();
      } else {
        self.QRAuthenticator.reconnect();
      }
    },
    disconnect () {
      this.QRAuthenticator.close();
    }
  }
};
